export enum EMealType {
  BREAKFAST = "아침",
  LUNCH = "점심",
  DINNER = "저녁",
}